module.exports = __webpack_public_path__ + "static/twitter_card-cbb8788286c2a48f71d615825c2e85f5.png";